import { render } from "./TotalRevenue.vue?vue&type=template&id=5071ba44"
import script from "./TotalRevenue.vue?vue&type=script&lang=js"
export * from "./TotalRevenue.vue?vue&type=script&lang=js"

import exportComponent from "/home/www/omniauto/omninext/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__